const items = [
  "Dossiers comptables",
  "Archives RH",
  "Contrats",
  "Documents administratifs",
  "Cartons d'archives",
];

export default function WhatWeTake() {
  return (
    <section
      className="py-24 md:py-36 bg-white"
      data-testid="whatwetake-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <div className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-blue-600">
              Ce que nous prenons en charge
            </div>
            <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-950" data-testid="whatwetake-title">
              Tous types de documents papier.
            </h2>
            <p className="mt-4 text-base md:text-lg text-slate-500 leading-relaxed max-w-md font-medium">
              Vrac, classeurs, cartons scellés ou armoires entières. Aucune limite de volume.
            </p>
          </div>

          {/* Right column — elegant divider list */}
          <div className="lg:col-span-7">
            <ul className="divide-y divide-slate-200 border-t border-slate-200">
              {items.map((label) => (
                <li
                  key={label}
                  className="py-5 md:py-6 flex items-baseline justify-between gap-4"
                  data-testid={`take-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                >
                  <span className="font-display text-xl md:text-2xl font-bold text-slate-950 tracking-tight">{label}</span>
                  <span className="text-xs text-slate-400 font-mono shrink-0">PAPIER</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
